import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14948b1d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style1 from "@Ai/sections/catalog-model-sets/catalog-model-page.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "@Ai/sections/catalog-model-sets/catalog-drawer.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14948b1d",
  null
  
)

export default component.exports